import pxToRem from "../../functions/pxToRem";

const dialogActions = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(10)} ${pxToRem(16)}`,
      gap: pxToRem(8),
    },
  },
};

export default dialogActions;
